import { readRuntimeConfig } from './runtimeConfig';
import type { RuntimeConfig } from './runtimeConfig';

export const DEFAULT_CLOUD_URL = 'https://app.tigerconnect.com';

export type ResolveCloudUrlInput = {
  buildTimeCloudUrl?: string;
  runtimeConfig?: RuntimeConfig;
};

const usable = (value: unknown): string | undefined =>
  typeof value === 'string' && value.trim() !== '' ? value.trim() : undefined;

export function resolveCloudUrl({
  buildTimeCloudUrl,
  runtimeConfig,
}: ResolveCloudUrlInput = {}): string {
  const config = runtimeConfig ?? readRuntimeConfig();
  return usable(config.cloudUrl) || usable(buildTimeCloudUrl) || DEFAULT_CLOUD_URL;
}

export default resolveCloudUrl;
